import {
  Component, Input, Output, EventEmitter,
} from '@angular/core';
import * as _ from 'lodash';

import { BaseModalComponent } from '../../../modal/_base-modal.component';


@Component({
  moduleId: module.id,
  selector: 'success-upload-modal',
  templateUrl: 'success-upload-modal.component.html',
  styleUrls: ['success-upload-modal.component.scss'],
})
export class SuccessUploadModalComponent extends BaseModalComponent {

  @Input() overflow: boolean = false;

  @Output() onHide: EventEmitter<any> = new EventEmitter();

  onHideModal() {
    this.onHide.emit();
  }
}
